module.exports = __webpack_public_path__ + "static/media/test14_2.74361ea0.png";